import { FC } from 'react'
import Image from 'next/legacy/image'

import styles from '../../styles/EmptyState.module.less'

const GRAPHICS_DIMENSION = 150

export const NoProductResults: FC = () => (
  <Image
    alt="Products not found"
    src="/fallbackGraphics/no-products.svg"
    height={GRAPHICS_DIMENSION}
    width={GRAPHICS_DIMENSION}
  />
)

export const NoSupplierResults: FC = () => (
  <img
    className={styles['empty-state-graphic-supplier-search']}
    alt="Suppliers not found"
    src="/fallbackGraphics/no-suppliers.svg"
  />
)

export const EmptyCartResultGraphic: FC = () => (
  <img
    className={styles['empty-state-graphic']}
    alt="Cart is empty"
    src="/fallbackGraphics/empty-cart.svg"
  />
)

export default NoProductResults
